import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";
import { useSettings } from "@/context/SettingsContext";
import { LEGAL_DOCS } from "@/lib/legal";
import NotFound from "@/pages/NotFound";

export default function Legal({ slug }) {
  const settings = useSettings();
  const doc = LEGAL_DOCS[slug];
  if (!doc) return <NotFound />;

  const contact = [settings?.phone, settings?.email].filter(Boolean).join(" · ") || "İletişim sayfamız üzerinden";
  const fill = (t) => t.replace("{contact}", contact);

  return (
    <>
      <Seo
        title={`${doc.title} | Meguiar's İzmit`}
        description={`Meguiar's İzmit ${doc.title.toLowerCase()}. ${doc.sections[0].body[0].slice(0, 120)}`}
        canonicalPath={`/${slug}`}
      />
      <PageHero
        overline={doc.overline}
        title={doc.title}
        subtitle={doc.updated}
        breadcrumbs={[{ label: "Ana Sayfa", to: "/" }, { label: doc.title }]}
        compact
      />

      <section className="obsidian py-14 sm:py-20">
        <div className="container-x max-w-3xl space-y-10">
          {doc.sections.map((s, i) => (
            <Reveal key={i} delay={(i % 3) * 0.05}>
              <div data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-xl font-medium text-white sm:text-2xl">{s.h}</h2>
                {s.body.map((p, j) => (
                  <p key={j} className="mt-3 text-base leading-relaxed text-neutral-300">{fill(p)}</p>
                ))}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
